<template>
  <div>
    <b-card title="Commission Fee">
      <!-- search input -->
      <div class="custom-search d-flex justify-content-start">
        <b-form-group>
          <div>
            <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="text"
              class="d-inline-block mr-1"
            />
          </div>
        </b-form-group>
      </div>

      <!-- table -->
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :rtl="direction"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: Name -->
          <span v-if="props.column.field === 'fixedType'">
            <span>{{
              props.row.commissionType === 2
                ? (props.row.fixedType = null)
                : props.row.fixedType === 1
                ? "Single"
                : "Range"
            }}</span>
          </span>
          <span v-else-if="props.column.field === 'amount'">
            <span>{{
              props.row.commissionType === 2
                ? props.row.amount
                : props.row.fixedType === 1
                ? props.row.amount
                : (props.row.amount = null)
            }}</span>
          </span>

          <span v-else-if="props.column.field === 'status'">
            <span>
              <b-badge
                v-if="props.row.status === 'Active'"
                pill
                variant="success"
              >
                Active
              </b-badge>
              <b-badge
                v-else-if="props.row.status === 'Closed'"
                pill
                variant="danger"
              >
                Closed
              </b-badge>
            </span>
          </span>
          <!-- Column: Action -->
          <span v-else-if="props.column.field === 'action'">
            <span>
              <b-link
                v-if="$can('Update', 'CommissionFee')"
                v-b-modal.modal-paymentoption
                @click="fetchDetailData(props.row.id)"
              >
                <span>Detail</span>
              </b-link>
            </span>
          </span>

          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLength"
                :options="['5', '10', '15', '30']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
      <b-modal
        id="modal-paymentoption"
        ref="modal"
        hide-footer
        title="Commission Details"
        size="lg"
      >
        <b-card-body>
          <b-row>
            <b-col md="6">
              <b-form-group class="d-flex p-1">
                Merchant: <strong>{{ commissionDetail.merchant }}</strong>
              </b-form-group>
              <b-form-group class="d-flex p-1">
                Commission Type:
                <strong
                  >{{ commissionDetail.commissionTypeDescription }}
                </strong>
              </b-form-group>
              <b-form-group class="d-flex p-1">
                Effective Date From:
                <strong> {{ commissionDetail.effectiveDateFrom }}</strong>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group class="d-flex p-1">
                Status:
                <strong> {{ commissionDetail.status }}</strong>
              </b-form-group>
              <b-form-group
                class="d-flex p-1"
                v-if="commissionDetail.commissionType === 1"
              >
                Fixed Type:
                <strong>
                  {{
                    commissionDetail.fixedType === 1 ? "Single" : "Range"
                  }}</strong
                >
              </b-form-group>

              <b-form-group class="d-flex p-1">
                Effective Date To:
                <strong> {{ commissionDetail.effectiveDateTo }} </strong>
              </b-form-group>
            </b-col>
            <b-col v-if="commissionDetail.fixedType === 2">
              <strong class="d-flex p-1">Commission Range: </strong>
              <hr />
              <b-row
                v-for="(item, index) in commissionDetail.commissionRange"
                :key="index"
                cols-md="6"
                class="d-flex p-2"
              >
                <b-col md="3">
                  Min Range : <strong>{{ item.minRange }} </strong>
                </b-col>
                <b-col md="3">
                  Max Range : <strong>{{ item.maxRange }} </strong>
                </b-col>
                <b-col md="3">
                  Amount : <strong>{{ item.amount }} </strong>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-overlay :show="isLoadingmodal" no-wrap rounded="sm" />
        </b-card-body>
      </b-modal>
      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BLink,
  BCol,
  BRow,
  BCardBody,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import axios from "@axios";
import store from "@/store";
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: "Roles",
  components: {
    BCard,
    VueGoodTable,
    BBadge,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BLink,
    BCol,
    BRow,
    BCardBody,
  },
  data() {
    return {
      isLoading: false,
      isLoadingmodal: false,
      pageLength: 5,
      isDeleteModel: false,
      dir: false,
      activeRow: null,
      columns: [
        {
          label: "Merchant",
          field: "merchant",
        },
        {
          label: "Commission Type",
          field: "commissionTypeDescription",
        },
        {
          label: "Fixed Type",
          field: "fixedType",
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Effective Date From",
          field: "effectiveDateFrom",
        },
        {
          label: "Effective Date To",
          field: "effectiveDateTo",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      commissionDetail: {},
      rows: [],
      searchTerm: "",
      editabelData: {},
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    accessTypeVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-info",
        2: "light-primary",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$store.dispatch("config/getActionPrivilege", "CommissionFee-GetAll");
      this.isLoading = true;
      axios
        .get("/Merchant/api/V1.0/Merchants/GetMerchantCommissionFee")
        .then((res) => {
          this.isLoading = false;
          this.rows = res.commissionFees;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    fetchDetailData(id) {
      this.isLoadingmodal = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-Detail");
      axios
        .get(`/Commission/api/V1.0/CommissionFee/GetById?id=${id}`)
        .then((res) => {
          this.commissionDetail = res.commissionFee;
          this.isLoadingmodal = false;
          // console.log(res)
        })
        .catch((res) => {
          console.log(res);
          this.isLoadingmodal = false;
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
